import React from 'react';

const STATUS_COLORS: Record<string, { bg: string; fg: string; bd: string }> = {
  approved:  { bg: '#e6f4ec', fg: '#0f7a44', bd: '#bfe5cd' },
  funded:    { bg: '#1f2328', fg: '#fff',    bd: '#1f2328' },
  declined:  { bg: '#fdeaea', fg: '#c93b3b', bd: '#f3c4c4' },
  missing:   { bg: '#fdf6e3', fg: '#c98a2a', bd: '#f0dba4' },
  contracts: { bg: '#fff',    fg: '#c98a2a', bd: '#f0dba4' },
  submitted: { bg: '#e6ecfb', fg: '#1d4ed8', bd: '#c8d5f3' },
};

const DEFAULT_COLOR = { bg: '#f1f3f6', fg: '#6b7280', bd: '#e3e6eb' };

interface StatusPillProps {
  status: string;
  label: string;
}

function StatusPill({ status, label }: StatusPillProps) {
  const c = STATUS_COLORS[status] || DEFAULT_COLOR;
  return (
    <span
      className="sky-status-pill"
      style={{
        background: c.bg,
        color: c.fg,
        border: `1px solid ${c.bd}`,
      }}
    >
      {label}
    </span>
  );
}

export default React.memo(StatusPill);
